import "./NoScoodleAccount.less";

import React, { Component } from "react";
import { translate } from "react-i18next";
import queryString from "query-string";
import { ForgottenProviderContext } from "../../../contexts/contexts";
import config from "../../../config";

class NoScoodleAccount extends Component {
	render() {
		const t = this.props.t;

		return (
			<ForgottenProviderContext.Consumer>
				{({provider}) => (
					<div className="no-scoodle-account">
						<p className="header">{t("description", { provider: provider === "Knooppunt3" ? t("common:knooppunt") : provider })}</p>

						<button type="submit" className="primarybtn" onClick={() => this.handleSubmitClick(provider)}>
							{t("submitButton", { provider: provider === "Knooppunt3" ? t("common:knooppunt") : provider })}
						</button>
					</div>
				)}
			</ForgottenProviderContext.Consumer>
		);
	}

	handleSubmitClick(provider) {
		const currentQuery = queryString.parse(window.location.search);
		const returnUrl = currentQuery.returnUrl;
		const clientId = config.identityServer.clientId;
		const culture = config.language + "-BE";

		const query = queryString.stringify({ provider, returnUrl, clientId, culture });
		window.location = `${config.identityServer.baseUrl}/Portal/LogInExternal?${query}`;
	}
}

export default translate("noScoodleAccount")(NoScoodleAccount);



// WEBPACK FOOTER //
// ./src/components/ForgottenPassword/NoScoodleAccount/NoScoodleAccount.js